import pngLogo from './logo.png';
import svgLogo from './logo.svg';

export const Logo = () => (
  <picture className="logo">
    <source type="image/svg+xml" srcSet={svgLogo} />
    <img src={pngLogo} alt="logo" />
  </picture>
);
